/**
 * Перечень врачей на странице клиники
 *
 * @param {Object} params
 * @param {String} params.urlApi - url обращения к api врачей
 * @param {String} params.urlApiSpecialization - url обращения к api специализаций врачей
 * @param {String} params.doctorsList - список врачей
 * @param {String} params.specializationsList - список специализаций
 * @param {String} params.specializationTitle - название специализации
 * @param {String} params.searchSpecialization - блок поиска специализации
 * @param {String} params.selectSpecialization - селект выбора специализации
 * @param {String} params.specializationField - поле поиска специализации
 * @param {String} params.specializationClear - кнопка очистки названия специализации
 * @param {String} params.forChildsField - селект выбора врача детский/взрослый
 * @param {String} params.fioField - поле ФИО
 * @param {String} params.fioClear - кнопка очистки ФИО
 * @param {String} params.cityId - активный город
 * @param {String} params.clinicId - активная клиника
 * @param {String} params.pagesLimit - лимит страниц
 * @param {String} params.ageForChilds - возрастные категории для селект выбора врача детский/взрослый - детский
 * @param {String} params.ageAdults - возрастные категории для селект выбора врача детский/взрослый - взрослый
 */
$.fn.doctorsListClinic = function (params) {
    const $self = $(this);
    const $doctorsList = $self.find(params.doctorsList);
    const $specializationsList = $self.find(params.specializationsList);
    const $specializationField = params.specializationField;
    const $specializationClear = params.specializationClear;
    const $forChildsField = params.forChildsField;
    const $fioField = params.fioField;
    const $fioClear = $self.find(params.fioClear);
    const selectSpecialization = params.selectSpecialization;
    const searchSpecialization = params.searchSpecialization;
    const specializationTitle = params.specializationTitle;
    const urlApi = params.urlApi;
    const urlApiSpecialization = params.urlApiSpecialization;
    const cityId = $self.attr(params.cityId);
    const activeClinic = $self.attr(params.clinicId);
    const pagesLimit = $self.attr(params.pagesLimit);
    const ageAdults = JSON.parse($doctorsList.attr(params.ageAdults));
    const ageForChilds = JSON.parse($doctorsList.attr(params.ageForChilds));

    let specialization = '';
    let fio = '';
    let forChilds = false;

    let updateDoctorsListTimerId = null;
    let specializationTimerId = null;
    const $specializationFieldBlock = $self.find($specializationField);

    /**
     * Выбор специализации врача
     */
    const bindSelectSpecializationClick = function () {

        $self.on('click', selectSpecialization, function () {

            let title = $(this).attr(specializationTitle);

            specialization = title;

            $self.find($specializationField).val(title);

            $self.find($specializationClear).show();

            if (updateDoctorsListTimerId) {
                clearInterval(updateDoctorsListTimerId);
            }
            updateDoctorsListTimerId = setTimeout (function () {
                update();
            }, 200)
        });

    };

    bindSelectSpecializationClick();

    /**
     * Блок поиска по специализации врача
     */
    $self.on('click', searchSpecialization, function () {
        $(this).toggleClass('suggest-available');
    });

    /**
     * События поля специализации врача
     */
    $specializationFieldBlock.on('change', function () {
        update();
        $specializationFieldBlock.empty();
        $specializationFieldBlock
            .closest('.js-search-filter-wrapper')
            .removeClass('suggest-available');
    });

    $specializationFieldBlock.on('keyup', function (e) {
        switch (e.key) {
            case 'ArrowDown':
                $(this).blur();
                $specializationFieldBlock
                    .find('.js-suggest-item a')
                    .first()
                    .focus();
                break;

            case 'Enter':
                $(this)
                    .blur()
                    .closest('.js-search-filter-wrapper')
                    .removeClass('suggest-available');
                break;
        }
    });

    $specializationFieldBlock.on('click', '.js-suggest-item', function () {
        let $t = $(this);
        $specializationFieldBlock
            .val($t.text().trim())
            .trigger('change');
    });

    $specializationFieldBlock.on('keydown', '.js-suggest-item a', function (e) {

        let $items =  $specializationFieldBlock.find('.js-suggest-item');
        let $currentItem = $(this).closest('.js-suggest-item');

        switch (e.key) {
            case 'ArrowDown':
                $items
                    .eq(($currentItem.index() + 1) % $items.length)
                    .find('a')
                    .focus();
                break;

            case 'ArrowUp':
                $items
                    .eq(($currentItem.index() + $items.length - 1) % $items.length)
                    .find('a')
                    .focus();
                break;
        }
        return false;
    });


    $specializationFieldBlock.on('focus input', function () {
        clearInterval(specializationTimerId);
        specializationTimerId = setTimeout(function () {
            updateSpecialization();
        }, 200);
    });

    /**
     * Переключатель врач - детский/взрослый
     */
    $self.find($forChildsField).click(function () {

        forChilds = !forChilds;
        update();
    });

    /**
     * Поле ФИО врача
     */
    $self.find($fioField).on('paste keyup change', function () {

        let value = $(this).val();

        if (value !== fio) {
            fio = value;
            update();
        }
    });

    /**
     * Очистка поля - ФИО врача
     */
    $fioClear.click(function () {

        fio = '';
        update();
    });

    /**
     * Рендер списка специализаций
     */
    const updateSpecialization = function () {

        let urlSpecialization = $self.attr(urlApiSpecialization);
        $.ajax({
            method: 'GET',
            url: urlSpecialization,
            data: {
                specialization: $specializationFieldBlock.val().trim(),
                clinic_id: activeClinic,
                is_children: forChilds,
            }
        }).done(function (res) {

            $specializationsList.html(res);
            bindSelectSpecializationClick();

            $specializationsList
                .closest('.js-search-filter-wrapper')
                .toggleClass('suggest-available', !!res); // если пришёл не пустой ответ - показываем список
        }).fail(function (error) {
            console.log(error);
        });

    };

    /**
     * Рендер списка врачей
     */
    const update = function () {
        /* updateSpecialization(specialization); */

        let requestAgePatientsIds = forChilds ? ageForChilds : ageAdults;
        let url = $self.attr(urlApi);

        $.ajax({
            method: 'GET',
            url: url,
            data: {
                fio: fio,
                specialization: $specializationFieldBlock.val().trim(),
                age_patients_ids: JSON.stringify(requestAgePatientsIds),
                city_id: cityId,
                clinic_id: activeClinic,
                pages_limit: pagesLimit,
                pagination_disable: true,
                is_children: forChilds,
            }
        }).done(function (res) {
            $doctorsList.html(res);
        }).fail(function (error) {
            console.log(error);
        });

    };

    return this;
};

// инициализация
const init = function () {


    $('#doctors-list-clinic-module').doctorsListClinic({
        urlApi: 'data-url-api',
        urlApiSpecialization: 'data-url-api-specializations',
        ageForChilds: 'data-age-for-childs',
        ageAdults: 'data-age-adults',
        doctorsList: $('#doctors-list'),
        specializationsList: $('#select-specialization-list'),
        specializationTitle: 'data-specialization-title',
        searchSpecialization: '#search-specialization',
        selectSpecialization: '[data-select-specialization="true"]',
        specializationField: $('[data-specialization-field="true"]'),
        specializationClear: $('[data-specialization-clear="true"]'),
        forChildsField: $('[data-for-childs-field="true"]'),
        fioField: $('[data-fio-field="true"]'),
        fioClear: $('[data-fio-clear="true"]'),
        cityId: 'data-city-id',
        clinicId: 'data-clinic-id',
        pagesLimit: 'data-pages-limit',
    });
};

if ($('#doctors-list-clinic-module').length > 0) {
    init();
}
